import React from "react";
import { createRoot } from 'react-dom/client';

import { Provider } from "react-redux";

import { BrowserRouter } from "react-router-dom";
import store from "./redux/store/store";

import App from "./App";

import "./index.css";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { MESSAGE } from "./common/message";

const root = createRoot(document.getElementById("root") as HTMLElement);
// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB-PeHPbX-l-JP_Ffkot3iKNB8pHkEcjuQ",
  authDomain: "vivachefs.firebaseapp.com",
  projectId: "vivachefs",
  storageBucket: "vivachefs.appspot.com",
  messagingSenderId: "301254041707",
  appId: "1:301254041707:web:8c9d632bf9eedb3945d12e",
  measurementId: "G-0K74YFL9ZX"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);


async function requestPermission() {
  try {
    // Request notification permission
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Notification permission granted.");

      try {
        // Get Firebase Cloud Messaging token
        const currentToken = await getToken(messaging, {
          vapidKey: "BAAqM_h3GgNQPG6Vc-Jxd7QY8tqO09fvruxVaB-jSAfytwMBzyj884VIkgKuZovmUCPlyWmwRvgBhvuJ5V994Gs"
        });

        if (currentToken) {
          console.log("Token retrieved successfully:", currentToken);

          // Prepare data for updating Firestore
          const updatedData = { token: currentToken };
          
          // Reference the Firestore document you want to update
          const userDocRef = doc(db, MESSAGE.userCollection, MESSAGE.adminId);

          // Update Firestore document with the token
          await updateDoc(userDocRef, updatedData);
          console.log("Token successfully updated in Firestore.");
        } else {
          console.log("No current token available.");
        }

      } catch (error) {
        console.error("Error retrieving token or updating Firestore:", error);
      }

    } else {
      console.log("Notification permission denied or dismissed.");
    }

  } catch (error) {
    console.error("Error requesting notification permission:", error);
  }
}

// Call the requestPermission function
requestPermission();


// Handle foreground messages
onMessage(messaging, (payload) => {
  const notificationTitle: any = payload?.notification?.title;
  const notificationOptions = {
    body: payload?.notification?.body,
    icon: payload?.notification?.icon,
  };
  new Notification(notificationTitle, notificationOptions);
});

root.render(
  // <React.StrictMode>
    <BrowserRouter basename={'/'}>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);
